export default "__VITE_ASSET__338dc64e__"